import React from 'react';
import { SVGProps } from './types';

function SquareLockIcon(props: SVGProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeWidth="1.042"
        d="M8.017 3.403H3.403v4.614m8.58-4.614h4.614v4.614m-4.614 8.58h4.614v-4.614m-8.58 4.614H3.403v-4.614M11.728 8.976V7.84c0-.954-.766-1.675-1.72-1.675s-1.736.72-1.736 1.675v1.136m-1.396 0h6.272v4.833H6.877V8.976z"
      />
    </svg>
  );
}

export { SquareLockIcon };
